/* =========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
==========================================================================================*/
import MsButton from '@/components/button/MsButton.vue';
import MsGroupButton from '@/components/button/MsGroupButton.vue';
import MsSplitButton from '@/components/button/MsSplitButton.vue';
import MsDropDownButton from '@/components/button/MsDropDownButton.vue';
import MsInput from '@/components/input/MsInput.vue';
import MsCheckbox from '@/components/checkbox/MsCheckbox.vue';
import MsRadio from '@/components/radio/MsRadio.vue';
import MsDatepicker from '@/components/datepicker/MsDatePicker.vue';
import MsDatePickerButton from '@/components/datepicker/MsDatePickerButton.vue';
import MsColorPicker from '@/components/colorpicker/MsColorPicker.vue';
import MsTextarea from '@/components/textarea/MsTextarea.vue';
import Descriptionarea from '@/components/descriptionarea/Descriptionarea.vue';
import MsNumber from '@/components/number/MsNumber.vue';
import MsComboBox from '@/components/combobox/MsCombobox.vue';
import MsComboboxEnum from '@/components/combobox/MsComboboxEnum.vue';
import MsDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import MsGridViewer from '@/components/gridViewer/MsGridViewer.vue';
import MsChart from '@/components/chart/MsChart.vue';
import MsTimePicker from '@/components/datepicker/MsTimePicker.vue';

export function useComponents(app) {
  app.component(MsButton.name, MsButton);
  app.component(MsGroupButton.name, MsGroupButton);
  app.component(MsSplitButton.name, MsSplitButton);
  app.component(MsDropDownButton.name, MsDropDownButton);
  app.component(MsInput.name, MsInput);
  app.component(MsCheckbox.name, MsCheckbox);
  app.component(MsRadio.name, MsRadio);
  app.component(MsDatepicker.name, MsDatepicker);
  app.component(MsDatePickerButton.name, MsDatePickerButton);
  app.component(MsColorPicker.name, MsColorPicker);
  app.component(MsTextarea.name, MsTextarea);
  app.component(Descriptionarea.name, Descriptionarea);
  app.component(MsNumber.name, MsNumber);
  app.component(MsComboBox.name, MsComboBox);
  app.component(MsComboboxEnum.name, MsComboboxEnum);
  app.component(MsDynamicPopup.name, MsDynamicPopup);
  app.component(MsGridViewer.name, MsGridViewer);
  app.component(MsChart.name, MsChart);
  app.component(MsTimePicker.name, MsTimePicker);
}
